export default {
    freeAccount: 'Sign Up',
    freeAccountVerbose: 'Sign Up for MyFreeCams',
    loadingModelCount: 'Loading model count',
    login: 'Log In',
    openMenu: 'Open Menu',
    recentNotifications: 'Recent Notifications',
    purchase: 'Purchase',
    purchaseTokens: 'Purchase Tokens',
    search: 'Search',
    searchFriends: 'Search Friends',
    searchMessages: 'Search Messages',
    searchNotes: 'Search Notes',
    tokens: 'Tokens',
    tokensAdded: 'tokens added!',
    openSidebar: 'Open Sidebar',
    closeSidebar: 'Close Sidebar',
}
